import React, { Component } from "react";
import ApiRequest from "../../libs/request";
import Nav from "./Nav";
import FeedNav from "./FeedNav";

function UsersList(_props) {
  if (!_props.users || _props.users.length === 0) {
    return (
      <div
        style={{
          padding: "30px",
          textAlign: "center",
          color: "#999",
          fontSize: "14px",
          backgroundColor: "#f9f9f9",
          borderRadius: "8px",
          border: "1px solid #e8e8e8",
        }}
      >
        No users found
      </div>
    );
  }
  let _items = [];

  _props.users.forEach((user, idx) => {
    var _btnCss =
      _props.pending.indexOf(user.id.toString()) > -1 ? "requested" : "";
    var _text =
      _props.pending.indexOf(user.id.toString()) > -1
        ? "ACCEPTED"
        : "ACCEPT";
    var hasAction = _props.hasAction;
    if (user.id === _props.user?.id) {
      hasAction = "none";
    }

    let userProfile = user.friend_from || user.friend;
    let userId = user.user_from || user.id;
    let friendId = user.friend_from?.id || user.friend?.id;

    if (userProfile) {
      _items.push(
        <div
          key={idx}
          className="friend-req-card"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "16px",
            marginBottom: "12px",
            backgroundColor: "#f9f9f9",
            borderRadius: "8px",
            border: "1px solid #e8e8e8",
            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
            transition: "all 0.2s ease",
            cursor: "pointer",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow = "0 4px 8px rgba(0, 0, 0, 0.1)";
            e.currentTarget.style.borderColor = "#ff9500";
            e.currentTarget.style.backgroundColor = "#fff";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow = "0 2px 4px rgba(0, 0, 0, 0.05)";
            e.currentTarget.style.borderColor = "#e8e8e8";
            e.currentTarget.style.backgroundColor = "#f9f9f9";
          }}
        >
          {/* User Info */}
          <div  style={{ display: "flex", alignItems: "center", gap: "16px", flex: 1 }}>
            <a
              href={"/user/profile/" + friendId + "#profile"}
              style={{ textDecoration: "none" }}
            >
              <img
                src={userProfile.profile_photo}
                alt="User"
                style={{
                  height: "50px",
                  width: "50px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  border: "2px solid #f0f0f0",
                  cursor: "pointer",
                }}
              />
            </a>
            <div>
              <a
                href={"/user/profile/" + friendId + "#profile"}
                style={{
                  textDecoration: "none",
                  color: "#000",
                }}
              >
                <p
                  style={{
                    margin: "0",
                    fontWeight: "600",
                    fontSize: "16px",
                    color: "#000",
                    cursor: "pointer",
                  }}
                >
                  {userProfile.first_name} {userProfile.last_name}
                </p>
              </a>
            </div>
          </div>

          {/* Action Buttons */}
          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
            {hasAction !== "none" && (
              <button
                id={userId}
                className="modern-primary-button"
                style={{
                  // padding: "8px 16px",
                  // backgroundColor: _btnCss ? "#4caf50" : "#ff9500",
                  // color: "white",
                  // border: "none",
                  // borderRadius: "6px",
                  // fontSize: "13px",
                  // fontWeight: "600",
                  // cursor: "pointer",
                  // whiteSpace: "nowrap",
                  // transition: "all 0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = _btnCss ? "#45a049" : "#ff8c00";
                  e.target.style.transform = "translateY(-2px)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = _btnCss ? "#4caf50" : "#ff9500";
                  e.target.style.transform = "translateY(0)";
                }}
                type="button"
                onClick={_props.onButtonClick}
              >
                 ✔ {_text}
              </button>
            )}

            {_props.hasRejection && hasAction !== "none" && (
              <button
                id={userId}
                className="modern-reject-btn"
                // style={{
                //   padding: "8px 16px",
                //   backgroundColor: "#f44336",
                //   color: "white",
                //   border: "none",
                //   borderRadius: "6px",
                //   fontSize: "13px",
                //   fontWeight: "600",
                //   cursor: "pointer",
                //   whiteSpace: "nowrap",
                //   transition: "all 0.2s ease",
                // }}
                // onMouseEnter={(e) => {
                //   e.target.style.backgroundColor = "#da190b";
                //   e.target.style.transform = "translateY(-2px)";
                // }}
                // onMouseLeave={(e) => {
                //   e.target.style.backgroundColor = "#f44336";
                //   e.target.style.transform = "translateY(0)";
                // }}
                type="button"
                onClick={_props.onRejectionClick}
              >
                REJECT
              </button>
            )}

            {_props.hasRemove && (
              <button
                id={friendId}
                className="modern-reject-btn"
                // style={{
                //   padding: "8px 16px",
                //   backgroundColor: "#757575",
                //   color: "white",
                //   border: "none",
                //   borderRadius: "6px",
                //   fontSize: "13px",
                //   fontWeight: "600",
                //   cursor: "pointer",
                //   whiteSpace: "nowrap",
                //   transition: "all 0.2s ease",
                // }}
                // onMouseEnter={(e) => {
                //   e.target.style.backgroundColor = "#616161";
                //   e.target.style.transform = "translateY(-2px)";
                // }}
                // onMouseLeave={(e) => {
                //   e.target.style.backgroundColor = "#757575";
                //   e.target.style.transform = "translateY(0)";
                // }}
                type="button"
                onClick={_props.onRemoveFriendClick}
              >
                REMOVE
              </button>
            )}
          </div>
        </div>
      );
    }
  });

  return (
    <div
      style={{
        marginBottom: "24px",
      }}
    >
      {_items.length === 0 ? (
        <div
          style={{
            padding: "30px",
            textAlign: "center",
            color: "#999",
            fontSize: "14px",
            backgroundColor: "#f9f9f9",
            borderRadius: "8px",
            border: "1px solid #e8e8e8",
          }}
        >
          No users found
        </div>
      ) : (
        _items
      )}
    </div>
  );
}

class Friends extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      users: [],
      pending: [],
      friends: [],
      requests: [],
    };
  }

  render() {
    return (
      <React.Fragment>
        <Nav user={this.state.user} />
        <div className="feed">
          <div className="row feed-container">
            <div className="col-md-3 col-lg-2 col-sm-12 feed-left">
              <FeedNav user={this.props.user} />
            </div>
            <div className="col-md-9 col-lg-10 col-sm-12 feed-center">
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "flex-start",
                  minHeight: "60vh",
                  padding: "20px",
                }}
              >
                <div
                className="mob-frnd-re-cont"
                  style={{
                    width: "100%",
                    // maxWidth: "1000px",
                    backgroundColor: "#fff",
                    borderRadius: "12px",
                    // boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
                    padding: "40px",
                  }}
                >
                  <div
                    id="alert"
                    className="alert alert-success"
                    style={{
                      display: "none",
                      marginBottom: "20px",
                      borderRadius: "8px",
                      borderLeft: "4px solid #4caf50",
                    }}
                  >
                    Friend Request Accepted
                  </div>

                  {/* Pending Friend Requests Section */}
                  <div style={{ marginBottom: "40px" }}>
                    <h2
                      style={{
                        marginBottom: "20px",
                        fontSize: "22px",
                        fontWeight: "700",
                        color: "#000",
                        borderBottom: "2px solid #ff9500",
                        paddingBottom: "12px",
                        display: "inline-block",
                      }}
                    >
                      Pending Friend Requests
                    </h2>
                    <div style={{ marginTop: "20px" }}>
                      <UsersList
                        users={this.state.users}
                        user={this.props.user}
                        hasAction={"block"}
                        onRejectionClick={this.handleRejectClick.bind(this)}
                        hasRejection={true}
                        pending={this.state.pending}
                        onButtonClick={this.handleVoucherClick.bind(this)}
                      />
                    </div>
                  </div>

                  {/* Friends Section */}
                  <div>
                    <h2
                      style={{
                        marginBottom: "20px",
                        fontSize: "22px",
                        fontWeight: "700",
                        color: "#000",
                        borderBottom: "2px solid #ff9500",
                        paddingBottom: "12px",
                        display: "inline-block",
                      }}
                    >
                      Friends
                    </h2>
                    <div style={{ marginTop: "20px" }}>
                      <UsersList
                        users={this.state.friends}
                        user={this.props.user}
                        onRemoveFriendClick={this.handleRemoveFriendClick.bind(this)}
                        hasAction={"none"}
                        hasRemove={true}
                        pending={this.state.pending}
                        onButtonClick={this.handleVoucherClick.bind(this)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  handleRejectClick(e) {
    var id = e.target.id;
    var api = new ApiRequest("post", "/user/reject-request/");
    api.send({ friend_id: id }, () => {
      var _alert = document.getElementById("alert");
      _alert.innerText = "Friend Request Denied";
      _alert.style.display = "block";

      this.loadFriends();
    });
  }

  handleRemoveFriendClick(e) {
    var id = e.target.id;
    var api = new ApiRequest("post", "/user/delete-friend");
    api.send({ friend_id: id }, () => {
      var _alert = document.getElementById("alert");
      _alert.innerText = "Friend Removed";
      _alert.style.display = "block";

      this.loadFriends();
    });
  }

  handleVoucherClick(e) {
    let _pending = this.state.pending;
    var id = e.target.id;
    // var api = new ApiRequest("post", "/friends/" + id + "/approve");
    var api = new ApiRequest("post", "/user/accept-request/");
    api.send({ friend_id: id }, () => {
      var _alert = document.getElementById("alert");
      _alert.innerText = "Friend Request Approved";
      _alert.style.display = "block";

      this.loadFriends();
      _pending.push(id);
      this.setState({pending: _pending});
    });
  }

  componentDidMount() {
    this.loadFriends();
  }

  loadFriends() {

    let api = new ApiRequest("get", "/user/view-requests?type=pending");
    api.send({}, (response) => {
      var _pending = response.data.requests;
      api.url = "/user/view-friends";
        api.send({}, (response) => {
          this.setState({ users: _pending });
          this.setState({ requests: [] });
          this.setState({ friends: response.data.friends });
        });
    });

    // let api = new ApiRequest("get", "/friends/pending");
    // api.send({}, (response) => {
    //   var _pending = response.data.data.friends;
    //   api.url = "/friends/requests";
    //   api.send({}, (response) => {
    //     var _requests = response.data.data.friends;

    //     api.url = "/friends";
    //     api.send({}, (response) => {
    //       this.setState({ users: _pending });
    //       this.setState({ requests: _requests });
    //       this.setState({ friends: response.data.data.friends });
    //     });
    //   });
    // });
  }
}

export default Friends;
